import { Box, Image, Text, CircularProgress } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetSelectedCourse, selectedMenu, setHeaderText } from "../../redux/actions/actions";
import IndividualLeadershipBoardCard from "./IndividualLeadershipBoardCard";
import Statistics from "./Statistics";
import { loadCourseLeadershipBoard, loadSelectedCourse } from "../../redux/api_calls/apiCalls";
import CourseName from "./CourseName";

export default function CourseDashboard(props) {
    const {selectedCourse, isLoading: selectedCourseIsLoading} = useSelector(state => state.selectedCourseState)
    const headerText = useSelector(state => state.headerState.headerText)
    const { courseLeadershipBoardData, isLoading, courseLeadershipBoardError } = useSelector(state => state.courseLeadershipBoardState)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setHeaderText('Course Dashboard'))
        dispatch(selectedMenu(1))
        dispatch(loadCourseLeadershipBoard(props.match.params.id))
        dispatch(loadSelectedCourse(props.match.params.id))
        return () => {
            dispatch(resetSelectedCourse())
        }
    }, [dispatch, props.match.params.id])

    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
            minH='90vh'
        >

            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>{headerText}</Text>
            </Box>


            <Box
                width='80%'
                d='flex'
                justifyContent='space-between'
                mb='1.5rem'
            >
                <Box
                    w='27.5%'
                    d='flex'
                    flexDir='column'
                >
                    <Text
                        fontSize='15px'
                        color='#222222'
                        fontWeight='800'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        mb='1rem'
                    >
                        LEADERSHIP BOARD
                    </Text>

                    <Box
                        w='100%'
                        border='1px solid rgba(0, 0, 0, 0.1)'
                        borderRadius='10px'
                        boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                        pt='1rem'
                        bg='#ffffff'
                        flex = '1'
                    >
                        <Box
                            d='flex'
                            justifyContent='space-between'
                            alignItems='center'
                            mb='1rem'
                            px='1rem'
                        // pr='0.5rem'
                        >
                            <Text variant='custom' fontSize='10px' fontWeight='800' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%'>RANK</Text>
                            <Text variant='custom' fontSize='10px' fontWeight='800' style={{ fontFamily: 'Mulish, sans-serif' }} width='65%' textAlign='start'>EMPLOYEE</Text>
                            <Text variant='custom' fontSize='10px' fontWeight='800' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%' textAlign='center'>SCORE</Text>
                        </Box>
                        {
                            isLoading ? <Box width='100%' d='flex' justifyContent='center' alignItems='center' my='0.5rem'>
                                <CircularProgress isIndeterminate color='#3e59de' size='50px' />
                            </Box> :
                                !isLoading && courseLeadershipBoardData.length > 0 ?
                                    courseLeadershipBoardData.map((employee, idx) => <IndividualLeadershipBoardCard employee={employee} id={idx} key={idx} />) :
                                    <Box width='100%' d='flex' justifyContent='center' alignItems='center'>
                                        <Text
                                            style={{ fontFamily: 'Mulish, sans-serif' }}
                                            fontSize='20px'
                                            fontWeight='600'
                                            color='#222222'
                                            textAlign='center'
                                        >
                                            {courseLeadershipBoardError ? courseLeadershipBoardError : `Nothing to display!`}
                                        </Text>
                                    </Box>
                        }

                    </Box>
                </Box>
                <Box
                    d='flex'
                    width='70%'
                    flexDir='column'
                    justifyContent = 'space-between'
                >
                    <CourseName title = {selectedCourse?.title} loading = {selectedCourseIsLoading} />
                    <Statistics course_id={props.match.params.id} />
                </Box>
            </Box>

            <Box
                width='80%'
                d='flex'
                justifyContent='space-between'
                flexDir='column'
            >
                <Text
                    fontSize='15px'
                    color='#222222'
                    fontWeight='800'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    mb='1rem'
                >
                    PERFORMANCE
                </Text>
                <Box
                    w='100%'
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    bg='#ffffff'
                    objectFit='cover'
                    mb='1rem'
                >
                    <Image src='/images/performance-graph.jpg' alt='Graph' objectFit='cover' width='100%' height='100%' borderRadius='10px' />
                </Box>

            </Box>

        </Box >
    )
}